import { useTranslation } from "react-i18next";
import { Plus } from "../icons";

interface DietaryRequirementsButtonProps {
  readonly dietaryCount: number;
  readonly onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Opens the dietary requirements modal. Shared by the place-your-order flow and
 * the booking journey's pre-order stage (the `/book` route and the
 * `<booking-form>` widget), which all render the same button.
 */
function DietaryRequirementsButton({ dietaryCount, onClick }: DietaryRequirementsButtonProps) {
  const { t } = useTranslation();
  return (
    <button type="button" className="add-dietary-requirements add-dietary-requirements--full-width" onClick={onClick}>
      {dietaryCount > 0 && <span className="dietary-badge">{dietaryCount}</span>}
      <Plus size={16} />
      <span>{t("add_dietary_requirements", "Allergens & dietary")}</span>
    </button>
  );
}

export default DietaryRequirementsButton;
export type { DietaryRequirementsButtonProps };
